import { createContext, FC, ReactNode, useContext } from 'react';
import { useRiveFile } from 'rive-react';
import SideBarMenuIcons from './sidebar-menu-icons.riv';
import { RiveFileState } from 'rive-react/dist/types/types';

const RiveFileContext = createContext<{
  riveFile: RiveFileState['riveFile'];
  fileStatus: RiveFileState['status'];
}>({ riveFile: null, fileStatus: 'loading' });

export const RiveProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { riveFile, status } = useRiveFile({
    src: SideBarMenuIcons,
  });

  return (
    <RiveFileContext.Provider value={{ riveFile, fileStatus: status }}>
      {children}
    </RiveFileContext.Provider>
  );
};

export const useRiveFileCache = () => {
  return useContext(RiveFileContext);
};
